import React, { useState } from 'react';
import './App.css';

// Main Components
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CapabilitiesSection from './components/CapabilitiesSection';
import ConsumerCategoriesSection from './components/ConsumerCategoriesSection';
import RetailDistributionApproachSection from './components/RetailDistributionApproachSection';
import WhyWorkWithUsSection from './components/WhyWorkWithUsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

// Legal Pages
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import Compliance from './components/Compliance';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  const handleNavigate = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  const handleBackToHome = () => {
    setCurrentPage('home');
    window.scrollTo(0, 0);
  };

  return (
    <div className="App">
      <Header onNavigate={handleNavigate} />
      
      {currentPage === 'home' ? (
        <>
          <HeroSection />
          <ConsumerCategoriesSection />
          <AboutSection />
          <CapabilitiesSection />
          <RetailDistributionApproachSection />
          <WhyWorkWithUsSection />
          <ContactSection />
        </>
      ) : currentPage === 'privacy' ? (
        <PrivacyPolicy onBack={handleBackToHome} />
      ) : currentPage === 'terms' ? (
        <TermsOfService onBack={handleBackToHome} />
      ) : currentPage === 'compliance' ? (
        <Compliance onBack={handleBackToHome} />
      ) : null}
      
      <Footer onNavigate={handleNavigate} />
    </div>
  );
}

export default App;
